import MenuMessage from "./MenuMessage.vue";
import MenuMessageFilled from "./Filled/MenuMessageFilled.vue";
import MenuRectangleHistory from "./MenuRectangleHistory.vue";
import MenuRectangleHistoryFilled from "./Filled/MenuRectangleHistoryFilled.vue";
import MenuInboxFull from "./MenuInboxFull.vue";
import MenuInboxFullFilled from "./Filled/MenuInboxFullFilled.vue";
import MenuChartPie from "./MenuChartPie.vue";
import MenuChartPieFilled from "./Filled/MenuChartPieFilled.vue";
import MenuGearComplex from "./MenuGearComplex.vue";
import MenuGearComplexFilled from "./Filled/MenuGearComplexFilled.vue";
import MenuMobileNotch from "./MenuMobileNotch.vue";
import MenuMobileNotchFilled from "./Filled/MenuMobileNotchFilled.vue";
import MenuFolderTree from "./MenuFolderTree.vue";
import MenuFolderTreeFilled from "./Filled/MenuFolderTreeFilled.vue";
import MenuBellRing from "./MenuBellRing.vue";
import MenuBellRingFilled from "./Filled/MenuBellRingFilled.vue";
import MenuUser from "./MenuUser.vue";
import MenuUserFilled from "./Filled/MenuUserFilled.vue";
import MenuUserGroup from "./MenuUserGroup.vue";
import MenuUserGroupFilled from "./Filled/MenuUserGroupFilled.vue";
import MenuUsers from "./MenuUsers.vue";
import MenuUsersFilled from "./Filled/MenuUsersFilled.vue";
import MenuUserLock from "./MenuUserLock.vue";
import MenuUserLockFilled from "./Filled/MenuUserLockFilled.vue";
import MenuPlugCircle from "./MenuPlugCircle.vue";
import MenuPlugCircleCheckFilled from "./Filled/MenuPlugCircleCheckFilled.vue";
import MenuGears from "./MenuGears.vue";
import MenuGearsFilled from "./Filled/MenuGearsFilled.vue";
import MenuRectanglesMixed from "./MenuRectanglesMixed.vue";
import MenuRectanglesMixedFilled from "./Filled/MenuRectanglesMixedFilled.vue";
import MenuImageLandshape from "./MenuImageLandshape.vue";
import MenuImageLandshapeFilled from "./Filled/MenuImageLandshapeFilled.vue";
import MenuSidebarFlipped from "./MenuSidebarFlipped.vue";
import MenuSidebarFlippedFilled from "./Filled/MenuSidebarFlippedFilled.vue";
import MenuDatabase from "./MenuDatabase.vue";
import MenuDatabaseFilled from "./Filled/MenuDatabaseFilled.vue";
import MenuRectangleTerminal from "./MenuRectangleTerminal.vue";
import MenuRectangleTerminalFilled from "./Filled/MenuRectangleTerminalFilled.vue";
import MenuObjectUngroup from "./MenuObjectUngroup.vue";
import MenuObjectUngroupFilled from "./Filled/MenuObjectUngroupFilled.vue";
import MenuGearComplexApi from "./MenuGearComplexApi.vue";
import MenuGearComplexApiFilled from "./Filled/MenuGearComplexApiFilled.vue";
import MenuUserCrown from "./MenuUserCrown.vue";
import MenuUserCrownFilled from "./Filled/MenuUserCrownFilled.vue";
import MenuRectangleAd from "./MenuRectangleAd.vue";
import MenuRectangleAdFilled from "./Filled/MenuRectangleAdFilled.vue";
import MenuSlidersUp from "./MenuSlidersUp.vue";
import MenuSlidersUpFilled from "./Filled/MenuSlidersUpFilled.vue";
import MenuBadgePercent from "./MenuBadgePercent.vue";
import MenuBadgePercentFilled from "./Filled/MenuBadgePercentFilled.vue";
import MenuBuildings from "./MenuBuildings.vue";
import MenuBuildingsFilled from "./Filled/MenuBuildingsFilled.vue";
import MenuSquare from "./MenuSquare.vue";
import MenuSquareFilled from "./Filled/MenuSquareFilled.vue";
import MenuSitemap from "./MenuSitemap.vue";
import MenuSitemapFilled from "./Filled/MenuSitemapFilled.vue";
import MenuUserHeadset from "./MenuUserHeadset.vue";
import MenuUserHeadsetFilled from "./Filled/MenuUserHeadsetFilled.vue";
import MenuBellConcierge from "./MenuBellConcierge.vue";
import MenuBellConciergeFilled from "./Filled/MenuBellConciergeFilled.vue";
import MenuPeopleLine from "./MenuPeopleLine.vue";
import MenuPeopleLineFilled from "./Filled/MenuPeopleLineFilled.vue";
import MenuMessageExclamation from "./MenuMessageExclamation.vue";
import MenuMessageExclamationFilled from "./Filled/MenuMessageExclamationFilled.vue";
import MenuMapLocationDot from "./MenuMapLocationDot.vue";
import MenuMapLocationDotFilled from "./Filled/MenuMapLocationDotFilled.vue";
import MenuEarthEurope from "./MenuEarthEurope.vue";
import MenuEarthEuropeFilled from "./Filled/MenuEarthEuropeFilled.vue";
import MenuBrowser from "./MenuBrowser.vue";
import MenuBrowserFilled from "./Filled/MenuBrowserFilled.vue";
import MenuFileContract from "./MenuFileContract.vue";
import MenuFileContractFilled from "./Filled/MenuFileContractFilled.vue";
import MenuCalendarDay from "./MenuCalendarDay.vue";
import MenuCalendarDayFilled from "./Filled/MenuCalendarDayFilled.vue";
import MenuClock from "./MenuClock.vue";
import MenuClockFilled from "./Filled/MenuClockFilled.vue";
import MenuCostManagement from "./MenuCostManagement.vue";
import MenuCostManagementFilled from "./Filled/MenuCostManagementFilled.vue";
import MenuFlag from "./MenuFlag.vue";
import MenuFlagFilled from "./Filled/MenuFlagFilled.vue";
import MenuFileMagnifyGlass from "./MenuFileMagnifyGlass.vue";
import MenuFileMagnifyGlassFilled from "./Filled/MenuFileMagnifyGlassFilled.vue";

export const menuIconConfig = {
  message: { component: MenuMessage },
  messageFilled: { component: MenuMessageFilled },
  rectangleHistory: { component: MenuRectangleHistory },
  rectangleHistoryFilled: { component: MenuRectangleHistoryFilled },
  inboxFull: { component: MenuInboxFull },
  inboxFullFilled: { component: MenuInboxFullFilled },
  chartPie: { component: MenuChartPie },
  chartPieFilled: { component: MenuChartPieFilled },
  gearComplex: { component: MenuGearComplex },
  gearComplexFilled: { component: MenuGearComplexFilled },
  mobileNotch: { component: MenuMobileNotch },
  mobileNotchFilled: { component: MenuMobileNotchFilled },
  folderTree: { component: MenuFolderTree },
  folderTreeFilled: { component: MenuFolderTreeFilled },
  bellRing: { component: MenuBellRing },
  bellRingFilled: { component: MenuBellRingFilled },
  user: { component: MenuUser },
  userFilled: { component: MenuUserFilled },
  userGroup: { component: MenuUserGroup },
  userGroupFilled: { component: MenuUserGroupFilled },
  users: { component: MenuUsers },
  usersFilled: { component: MenuUsersFilled },
  userLock: { component: MenuUserLock },
  userLockFilled: { component: MenuUserLockFilled },
  plugCircle: { component: MenuPlugCircle },
  plugCircleFilled: { component: MenuPlugCircleCheckFilled },
  gears: { component: MenuGears },
  gearsFilled: { component: MenuGearsFilled },
  rectanglesMixed: { component: MenuRectanglesMixed },
  rectanglesMixedFilled: { component: MenuRectanglesMixedFilled },
  imageLandshape: { component: MenuImageLandshape },
  imageLandshapeFilled: { component: MenuImageLandshapeFilled },
  sidebarFlipped: { component: MenuSidebarFlipped },
  sidebarFlippedFilled: { component: MenuSidebarFlippedFilled },
  database: { component: MenuDatabase },
  databaseFilled: { component: MenuDatabaseFilled },
  rectangleTerminal: { component: MenuRectangleTerminal },
  rectangleTerminalFilled: { component: MenuRectangleTerminalFilled },
  objectUngroup: { component: MenuObjectUngroup },
  objectUngroupFilled: { component: MenuObjectUngroupFilled },
  gearComplexApi: { component: MenuGearComplexApi },
  gearComplexApiFilled: { component: MenuGearComplexApiFilled },
  userCrown: { component: MenuUserCrown },
  userCrownFilled: { component: MenuUserCrownFilled },
  rectangleAd: { component: MenuRectangleAd },
  rectangleAdFilled: { component: MenuRectangleAdFilled },
  slidersUp: { component: MenuSlidersUp },
  slidersUpFilled: { component: MenuSlidersUpFilled },
  badgePercent: { component: MenuBadgePercent },
  badgePercentFilled: { component: MenuBadgePercentFilled },
  buildings: { component: MenuBuildings },
  buildingsFilled: { component: MenuBuildingsFilled },
  square: { component: MenuSquare },
  squareFilled: { component: MenuSquareFilled },
  sitemap: { component: MenuSitemap },
  sitemapFilled: { component: MenuSitemapFilled },
  userHeadset: { component: MenuUserHeadset },
  userHeadsetFilled: { component: MenuUserHeadsetFilled },
  bellConcierge: { component: MenuBellConcierge },
  bellConciergeFilled: { component: MenuBellConciergeFilled },
  peopleLine: { component: MenuPeopleLine },
  peopleLineFilled: { component: MenuPeopleLineFilled },
  messageExclamation: { component: MenuMessageExclamation },
  messageExclamationFilled: { component: MenuMessageExclamationFilled },
  mapLocationDot: { component: MenuMapLocationDot },
  mapLocationDotFilled: { component: MenuMapLocationDotFilled },
  earthEurope: { component: MenuEarthEurope },
  earthEuropeFilled: { component: MenuEarthEuropeFilled },
  browser: { component: MenuBrowser },
  browserFilled: { component: MenuBrowserFilled },
  fileContract: { component: MenuFileContract },
  fileContractFilled: { component: MenuFileContractFilled },
  calendarDay: { component: MenuCalendarDay },
  calendarDayFilled: { component: MenuCalendarDayFilled },
  clock: { component: MenuClock },
  clockFilled: { component: MenuClockFilled },
  cronJobManagement: { component: MenuClock },
  cronJobManagementFilled: { component: MenuClockFilled },
  flag: { component: MenuFlag },
  flagFilled: { component: MenuFlagFilled },
  fileMagnifyGlass: { component: MenuFileMagnifyGlass },
  fileMagnifyGlassFilled: { component: MenuFileMagnifyGlassFilled },
  costManagement: { component: MenuCostManagement },
  costManagementFilled: { component: MenuCostManagementFilled }
};
